import React from "react"
import { PropsWithChildren } from "react"
import { EnvironmentType } from "./envTypes"
import { useMatchEnvironment } from "./envHooks"

type MatchEnvironmentProps = Readonly<
    PropsWithChildren<{
        environments: EnvironmentType[]
    }>
>

export function MatchEnvironment({ environments, children }: MatchEnvironmentProps) {
    const match = useMatchEnvironment(environments)

    if (match) {
        return <>{children}</>
    }

    return null
}
